<template>
  <div id="toexpandinto">
    <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->

    <v-container
      style="width: 100%"
      id="recent-container"
      class="px-0"
      v-if="lst_stats.length > 0"
    >
      <h4 class="mb-2">Team 51/55</h4>
      <v-card
        style="width: 100%"
        :id="'edt' + stat.rpd_stat_27_Id"
        v-for="stat in lst_stats"
        :key="stat.id"
        class="mx-auto mb-2 recent-card"
      >
        <v-card-text>
          <div style="display: none"></div>

          <v-row dense>
            <v-col cols="12" class="col-md-12 pa-0 d-flex">
              <div class="font-weight-bold">Team:</div>
              <p class="mb-0 ml-2">
                {{ stat.team }}
                <!-- <span class="ml-1">{{ stat.mil_time }}</span> -->
              </p>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Stat Date:</div>
              <p class="mb-0 ml-2">
                {{ stat.stat_date | shortDate }}
                <!-- <span class="ml-1">{{ stat.mil_time }}</span> -->
              </p>
            </v-col>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Last modified:</div>
              <p class="mb-0 ml-2">
                {{ stat.s_date | shortDate }}
                <!-- <span class="ml-1">{{ stat.mil_time }}</span> -->
              </p>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Edited:</div>
              <p class="mb-0 ml-2">
                {{ stat.s_user }}
              </p>
            </v-col>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Created:</div>
              <p class="mb-0 ml-2">
                {{ stat.s_created }}
              </p>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" class="col-md- pa-0 d-flex">
              <div class="font-weight-bold">Area:</div>
              <p class="mb-0 ml-2">
                {{ stat.area }}
              </p>
            </v-col>
          </v-row>
        </v-card-text>

        <v-container class="checkbox-chips pt-0 mt-2 ml-2">
          <v-row v-if="is_admin == false">
            <v-col cols="12" class="d-flex justify-space-around">
              <v-btn
                v-on:click="view(stat)"
                color="cmpbk"
                class="white--text"
                style="font-size: smaller"
                >View</v-btn
              >
            </v-col>
          </v-row>
          <v-row v-if="is_admin">
            <v-col cols="12" class="d-flex justify-space-around">
              <v-btn
                v-on:click="edit(stat)"
                color="cmpbk"
                class="white--text"
                style="font-size: smaller"
                >Edit</v-btn
              >
              <v-btn
                v-on:click="delete_ask(stat)"
                color="cmpbk"
                class="white--text"
                style="font-size: smaller"
                >Delete</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
    <div
      id="intersect"
      v-intersect="{
        handler: onIntersect,
        options: {
          threshold: [0.1],
        },
      }"
      class="invisible pb-8"
    ></div>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
/* 0 media q */
@media (min-width: 0px) {
  .grant_disp {
    width: 13%;
  }
  .lbl-lst-mod {
    width: 30%;
  }
  .p-date {
    width: 69%;
  }
  .lbl-user {
    width: 11%;
  }
  .p-user {
    width: 88%;
  }
  .lbl-type {
    width: 12%;
  }
  .p-type {
    width: 87%;
  }
  .lbl-loc {
    width: 18%;
  }
  .p-loc {
    width: 200%;
    padding-right: 20px;
  }
  .lbl-details {
    width: 90%;
  }
  .cnt_disp span {
    color: rgb(9, 9, 243);
  }
  .recent-card {
    max-width: 344px;
  }

  .accident {
    font-size: smaller;
  }
}
.invisible {
  width: 0;
  height: 0;
  position: absolute;
  bottom: 0;
}

/* 768 media q */
@media (min-width: 768px) {
  .lbl-lst-mod {
    width: 15%;
  }
  .p-date {
    width: 84%;
  }
  .lbl-user {
    width: 7%;
  }
  .p-user {
    width: 92%;
  }
  .lbl-type {
    width: 6%;
  }
  .p-type {
    width: 93%;
  }
  .lbl-loc {
    width: 10%;
  }
  .p-loc {
    width: 89%;
  }
  .lbl-details {
    width: 90%;
  }
  .recent-card {
    max-width: 90%;
  }
}

/* ipad lansdscape */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";

export default {
  name: "recent27",
  mixins: [bus_common],
  props: ["update_recent27"],
  components: {},
  data() {
    return {
      stat_data_map: {},
      map_dialog_visible: false,
      bReady_to_update: false,
      group_size: 4,
      total_loaded: 0,
      lst_stats: [],
      // stats: [
    };
  },
  watch: {
    update_recent27: {
      deep: true,
      immediate: true,
      handler(val) {
        if (this.bReady_to_update && val != null) {
          this.total_loaded = 0;
          this.get_recent_stats27();
        }
      },
    },
  },
  computed: {
    is_admin: function () {
      if (this.$store.state.user.roles.indexOf("stat-admin") > -1) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    message1() {
      alert("This button will go to maps");
    },
    message2() {
      alert("This button takes you back to add/edit.");
    },
    message3() {
      alert("This button will delete record");
    },
    show_map(stat) {
      this.stat_data_map = stat;
      this.map_dialog_visible = true;
    },
    close_mapdiag(loc) {
      this.stat_data_map = {};
      this.map_dialog_visible = false;
    },
    view(stat) {
      this.$emit("view27", stat, document.documentElement.scrollTop);
    },
    edit(stat) {
      this.$emit("edit", stat, document.documentElement.scrollTop);
    },
    onIntersect(entries, observer, isIntersecting) {
      if (isIntersecting && this.bReady_to_update) {
        this.get_next();
      }
    },
    //   get_updated_stats() {
    //   console.log("get_updated_stats");

    //   var self = this;

    //   var formIn = {};
    //   formIn.email = this.$store.state.user.email;
    //   formIn.token = this.$store.state.user.token;
    //   formIn.group_size = this.group_size;
    //   formIn.total_loaded = this.total_loaded;

    //   formIn.apiname = "get_updated_stats";
    //   var self = this;
    //   this.$store
    //     .dispatch("anyapi", formIn)
    //     .then((data) => {
    //       this.lst_stats = this.mno(data);
    //     })
    //     .catch((msg) => {
    //       this.show_loader(false);
    //       this.swall_it("Error", msg, "error", null, null);
    //     });
    // },
    delete_ask(stat) {
      var self = this;
      this.swall_diag(
        "Confirm Delete",
        "You are deleting an item created by '" + stat.s_user + "'. Continue?",
        "question",
        function () {
          console.log("Del id 1: " + stat.rpd_stat_27_Id);
          self.delete_now(stat);
        },
        null,
        null,
        function () {}
      );
    },
    delete_now(stat) {
      console.log("Del id: " + stat.rpd_stat_27_Id);
      this.$emit("delete_now27", stat, "recent");
      var index = this.lst_stats.findIndex(
        (item) => item.rpd_stat_27_Id === stat.rpd_stat_27_Id
      );
      this.lst_stats.splice(index, 1);
    },
    get_next() {
      //add to lsit of stat items
      console.log("intesect");

      this.total_loaded += this.group_size;

      var self = this;

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.group_size = this.group_size;
      formIn.total_loaded = this.total_loaded;

      formIn.apiname = "get_recent_rpd_stats27";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          console.log("new stuff " + data.length);
          var stats_to_add = this.mno(data);
          for (let index = 0; index < stats_to_add.length; index++) {
            const stat = stats_to_add[index];
            stat.mil_time = self.frm_jsDate_toMilTime(stat.s_date);
            self.lst_stats.push(stat);
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    get_recent_stats27() {
      var self = this;

      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.group_size = this.group_size;
      formIn.total_loaded = this.total_loaded;

      formIn.apiname = "get_recent_rpd_stats27";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.lst_stats = self.mno(data);
          for (let index = 0; index < self.lst_stats.length; index++) {
            var stat = self.lst_stats[index];
            stat.mil_time = this.frm_jsDate_toMilTime(stat.s_date);
          }
          this.bReady_to_update = true;
          self.$emit("open_recent");
          this.show_loader(false);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    init() {
      this.get_recent_stats27();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
